import axios from "axios";
import {
  INVENTORY_ADJUSTMENTS_QUERY_KEY,
  INVENTORY_ADJUSTMENTS_ACTIVITIES_QUERY_KEY,
} from "consts";
import { queryCache, useMutation } from "react-query";
import { ChangeAssignee } from "../types";

const changeAssignee = async ({ ids, assigneeId: userId }: ChangeAssignee) => {
  const isBulkAssign = ids.length > 1;
  const { data } = isBulkAssign
    ? await axios.post("overallAdjustment/bulkAssign", {
        overallAdjustmentIds: ids,
        userId,
      })
    : await axios.post("overallAdjustment/assign", {
        overallAdjustmentId: ids[0],
        userId,
      });

  return data;
};

const useAssignInventoryAdjustments = () =>
  useMutation(changeAssignee, {
    throwOnError: true,
    onSuccess: () => {
      queryCache.invalidateQueries(INVENTORY_ADJUSTMENTS_QUERY_KEY);
      queryCache.invalidateQueries(INVENTORY_ADJUSTMENTS_ACTIVITIES_QUERY_KEY);
    },
  });

export default useAssignInventoryAdjustments;
